import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getAdminDashboard = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/dashboard/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Admin dashboard fetch error:", error);
    throw error;
  }
};

export { getAdminDashboard };
